// Ignore the wizard's untouched placeholder, but never discard entered job details.
export function isEmptyClaimJob(job: Utils.FormData<Model.IClaimJob>) {
  return !(
    job.claimTypeId ||
    job.customerComplaint?.trim() ||
    job.cause?.trim() ||
    job.correction?.trim() ||
    job.claimJobItems?.length ||
    job.claimJobDocuments?.length ||
    job.dataPoints?.length
  );
}
